/**
 * Used to create an identifier for an argument to the constructor of a
 * transformed, lazy-build specific class.
 */
export const HOST_REF_ARG = 'hostRef';
